import { faCode } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Button, Card, Row, Col } from 'react-bootstrap'
import UserService from "../controllers/UserService";
import strengths from "../files/strengths.json";


const SumStoryPerson = props => {
    const [answer, setAnswer] = useState([]);
    const [answer1, setAnswer1] = useState('');
    const [answer2, setAnswer2] = useState('');
    const [activityQuestions, setActivityDetail] = useState([]);
    const [attenders, setAttenders] = useState(0);
    const [maxStudent, setMaxStudent] = useState(0);
    const [title, setTitle] = useState('');

    useEffect(() => {
        UserService.getActivityDetail(props.activityId).then((res) => {
            console.log(res);
            var questions = [
                res.data.data.topic.questions[0].content,
                res.data.data.topic.questions[1].content,
                res.data.data.topic.questions[2].content,
            ]
            setActivityDetail(questions)
            setMaxStudent(res.data.data.maxStudent);
            setTitle(res.data.data.topic.title)
            if (res.data && res.data.data && res.data.data.attenders) {
                setAttenders(res.data.data.attenders.length);
            } else {
                setAttenders(0);
            }

            UserService.getAnswersByStudentId(props.activityId, res.data.data.topic.questions[0].id, props.studentId).then((res) => {

                if (res && res.answer) {
                    console.log(res.answer);
                    var path = [
                        `/images/strengths/cards/${res.answer[0]}.png`,
                        `/images/strengths/cards/${res.answer[1]}.png`,
                        `/images/strengths/cards/${res.answer[2]}.png`,
                    ];

                    console.log(path);
                    setAnswer(path);
                }
            })

            UserService.getAnswersByStudentId(props.activityId, res.data.data.topic.questions[1].id, props.studentId).then((res) => {
                if (res && res.answer) {
                    setAnswer1(res.answer);
                }
            })

            UserService.getAnswersByStudentId(props.activityId, res.data.data.topic.questions[2].id, props.studentId).then((res) => {
                if (res && res.answer) {
                    setAnswer2(res.answer);
                }
            })

        })
    }, []);

    let html = (
        <Row className="blue-bg">
            <Col className="sum-story p-0 blue-bg font-sarabun">
                {(props.activityMode && props.activityMode === 'activity-summary') ?
                    <Row className="mx-0 mb-3">
                        <Col className="main-detail px-4">
                            <h2 className="primary-text font-weight-600">{title}</h2>
                        </Col>
                    </Row>
                    :
                    <Row className="pt-2">
                        <Col className="main-detail px-4">
                            <Row>
                                <Col xs={12} className="text-center d-block d-md-none">
                                    <h2 className="primary-text font-weight-600">สรุปกิจกรรม ประจำวันที่ <span className="doNotWrap">{props.date}</span></h2>
                                </Col>
                                <Col md={8} className="text-left d-none d-md-inline">
                                    <h2 className="primary-text font-weight-600">สรุปกิจกรรม ประจำวันที่ <span className="doNotWrap">{props.date}</span></h2>
                                </Col>

                                <Col xs={12} md={4} className="d-flex">
                                    <Button className="bluesky d-inline py-1 py-md-2 px-5 btn font-sarabun-bold btn btn-primary export-btn" href={`/report/pdffile/person/${props.activityId}/answer/${props.studentId}`} target="_blank"><h5 className="mb-0 font-weight-bold">Export</h5></Button>
                                </Col>
                            </Row>
                            <hr className="d-none d-md-block w-100 m-0 mt-3" style={{ "borderTop": '1px solid #D5E3FB' }}></hr>
                            {/* <Row className="pt-0 mt-3 pb-0">
                                <Col>
                                    <h4 className="py-1 bg-blue-grey border-radius-5"><b>จำนวนนักเรียนที่ร่วมกิจกรรม {attenders}/{maxStudent}</b></h4>
                                </Col>
                            </Row> */}
                        </Col>
                    </Row>
                }


                <Row className="pt-3 mx-0">
                    <Col className="primary-text main-detail px-4">
                        <h3 className="pb-0 mb-0 font-weight-600">เลือกตอบ 3 คุณค่าจากนิสัยเชิงบวก (3/3)</h3>
                    </Col>
                </Row>

                <Row className="py-3 mx-0">
                    <Col className="text-left main-detail px-4">
                        <h4>{activityQuestions[0]}</h4>
                    </Col>
                </Row>
                <Row className="py-3 mx-0">
                    <Col className="main-detail px-4 d-md-flex">
                        <div className="col-12 col-md-4 mb-3" data-value="1"><img src={answer[0]} className="d-inline w-100 border-radius-12 border-gray card-strength-drop-shadow" /></div>
                        <div className="col-12 col-md-4 mb-3" data-value="1"><img src={answer[1]} className="d-inline w-100 border-radius-12 border-gray card-strength-drop-shadow" /></div>
                        <div className="col-12 col-md-4" data-value="1"><img src={answer[2]} className="d-inline w-100 border-radius-12 border-gray card-strength-drop-shadow" /></div>
                    </Col>
                </Row>

                <Row className="pt-4 pt-md-5 mt-3 bg-white mx-0">
                    <Col className="primary-text main-detail px-4">
                        <h3 className="pb-0 mb-0 font-weight-600">มุมมองของนักเรียนที่มีต่อเรื่องราวนี้</h3>
                    </Col>
                </Row>

                <Row className="py-3 mx-0 bg-white">
                    <Col className="text-left main-detail px-4">
                        <h4>{activityQuestions[1]}</h4>
                    </Col>
                </Row>
                <div className="p-3 anywhere-wrap bg-white">
                    <Col className="main-detail px-2 px-md-4">
                        <div className="p-3 div-ans border-radius-12 w-100" >
                            <div className="answer-box text-left">
                            {answer1}
                            </div>
                        </div>
                    </Col>
                </div>

                <Row className="mt-0 bg-light-blue mx-0" style={{ 'height': '20px' }} />

                <Row className="pt-4 pt-md-5 bg-white mx-0">
                    <Col className="primary-text main-detail px-4">
                        <h3 className="pb-0 mb-0 font-weight-600">แรงบันดาลใจที่ได้รับจากเรื่องราว</h3>
                    </Col>
                </Row>

                <Row className="py-3  bg-white mx-0">
                    <Col className="text-left main-detail px-4">
                        <h4>{activityQuestions[2]}</h4>
                    </Col>
                </Row>
                <div className="p-3 anywhere-wrap bg-white pb-5" >
                    <Col className="main-detail px-2 px-md-4">
                        <div className="p-3 div-ans border-radius-12 w-100" >
                            <div className="answer-box text-left">
                                {answer2}
                            </div>
                            
                        </div>
                    </Col>
                </div>
                {(props.showBackTo && props.showBackTo === "1") && (
                    <Row className="pb-3 py-md-3 bg-white mx-0">
                        <Col className="main-detail px-4">
                            <Button href="/activity" className="bluebtn d-inline py-1 py-md-2 px-3 font-weight-600 font-sarabun-bold">กลับหน้าหลัก</Button>
                        </Col>
                    </Row>
                )}
            </Col >
        </Row>

    );


    return (
        <div>
            {html}
        </div>
    )

}

export default SumStoryPerson